import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppInfoService } from 'core/app-info/app-info.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActiveTabIndex, getActiveTabIndex } from 'src/app/modules/shared/entities/active-tab.enum';

@Component({
  selector: 'app-quotes-subsections-toggles',
  templateUrl: './quotes-subsections-toggles.component.html',
  styleUrl: './quotes-subsections-toggles.component.scss',
  standalone: false
})
export class QuotesSubsectionsTogglesComponent implements OnInit {
  @Input() activeTab: string;
  @Input() isOnAccountsPage: boolean;

  appStrings = this.appInfoService.appStrings;
  isMobile = false;
  isNsLocaleSelected: boolean;

  activeTabIndex: ActiveTabIndex;
  mobileToggleValues = [];
  toggleValues = [];

  constructor(
    private router: Router,
    private appInfoService: AppInfoService,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit(): void {
    this.isNsLocaleSelected = this.appInfoService.isNSLocaleSelected();
    this.isMobile = this.deviceService.isMobile();
    this.activeTabIndex = getActiveTabIndex(this.activeTab);
    this.setupMobileToggleButtons();
    this.setupToggleButtons();
  }

  onTabChange(tab: any) {
    this.activeTabIndex = ActiveTabIndex[tab.value.split(' ').join('') as keyof typeof ActiveTabIndex];
    if (this.activeTabIndex === ActiveTabIndex.OpenQuotes) {
      this.router.navigate(['/quotes']);
    } else if (this.activeTabIndex === ActiveTabIndex.TransactionHistory) {
      this.router.navigate(['/orders']);
    } else if (this.activeTabIndex === ActiveTabIndex.LNOrders) {
      this.router.navigate(['/ln-orders']);
    } else if (this.activeTabIndex === ActiveTabIndex.Invoices) {
      this.router.navigate(['/invoices']);
    }
  }

  private setupMobileToggleButtons() {
    this.mobileToggleValues = [{
      value: this.appStrings.menu_openQuotes
    }, {
      value: this.appStrings.menu_transactionHistory
      // TODO: add pages
      // }, {
      //   value: this.appStrings.menu_lnOrders
      // }, {
      //   value: this.appStrings.menu_Invoices
    }];
  }

  private setupToggleButtons() {
    this.toggleValues = [{
      value: this.appStrings.menu_openQuotes
    }, {
      value: this.appStrings.menu_transactionHistory
    }, ...(!this.isNsLocaleSelected ? [{
      value: this.appStrings.menu_lnOrders
    },{
      value: this.appStrings.menu_Invoices
    }] : [])];
  }
}
